import "./insQuartileRanking.scss";
import "common/common.scss";
import { isEmpty, isNull, isUndefined } from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import { InsQueryStatedElement } from "../base/insQueryStatedElement";
import { useGetBenchmarkFooter } from "../chart/base/utils";
import { useWidgetComponentProps } from "../hooks/use-current-widget";
import { numberFormatters } from "common";
import { InsWidget, InsWidgetTitle } from "components/widgets/base";
import { useGetDatapointsWidgetData } from "hooks/widget-data/use-datapoints";
import { language } from "language/default";
export const getValue = (ranking) => {
    const { value } = ranking;
    const unitValue = value;
    if (!isUndefined(unitValue?.value) && !isNull(unitValue?.value)) {
        const { value: valueForUnit, unit } = unitValue;
        return { unit, value: valueForUnit };
    }
    const areaValue = value;
    if (!isUndefined(areaValue?.area) && !isNull(areaValue?.area)) {
        const { area: valueForArea, unit } = areaValue;
        return { unit, value: valueForArea };
    }
    return { value: value };
};
export const InsQuartileRankingRow = ({ ranking, keyColumnWidth, valueColumnWidth }) => {
    const theme = useSelector((state) => state.theme.themeName);
    const inactiveCssClass = "inactive";
    const bottomQuartileInactive = ranking.ranking === 1 ? "" : inactiveCssClass;
    const lowerMidQuartileInactive = ranking.ranking === 2 ? "" : inactiveCssClass;
    const upperMidQuartileInactive = ranking.ranking === 3 ? "" : inactiveCssClass;
    const topQuartileInactive = ranking.ranking === 4 ? "" : inactiveCssClass;
    return React.createElement("div", { className: "quartile-ranking-row" },
        React.createElement("div", { className: `quartile-column-width-${Math.ceil(keyColumnWidth / 8)}` }, ranking.name),
        React.createElement("div", { className: `value-column quartile-column-width-${Math.ceil(valueColumnWidth / 8)}` },
            ranking.formatedValue,
            React.createElement("br", null)),
        React.createElement("div", { className: `quartiles quartiles-${theme}` },
            React.createElement("div", { className: `bottom_quartile ${bottomQuartileInactive}` },
                React.createElement("span", null, language.en.widgets.quartileRanking.bottom)),
            React.createElement("div", { className: `lower_mid_quartile ${lowerMidQuartileInactive}` },
                React.createElement("span", null, language.en.widgets.quartileRanking.lowerMid)),
            React.createElement("div", { className: `upper_mid_quartile ${upperMidQuartileInactive}` },
                React.createElement("span", null, language.en.widgets.quartileRanking.upperMid)),
            React.createElement("div", { className: `top_quartile ${topQuartileInactive}` },
                React.createElement("span", null, language.en.widgets.quartileRanking.top))));
};
export const getFirstLeafNode = (items) => {
    const firstItem = items?.[0];
    if (!firstItem) {
        return undefined;
    }
    return firstItem.data?.length ? getFirstLeafNode(firstItem.data) : firstItem;
};
export const InsQuartileRanking = (props) => {
    const { sectionId, widgetId } = props;
    const { footer } = useWidgetComponentProps(sectionId, widgetId);
    const [response, querystate] = useGetDatapointsWidgetData(props);
    const benchmarkText = useGetBenchmarkFooter(footer?.text, response?.[0]?.additionalData);
    let customMeasures = {};
    if (querystate && querystate.isFinished && !querystate.isPending && response && response.length) {
        customMeasures = getFirstLeafNode(response?.[0]?.data)?.customMeasures ?? {};
    }
    let longestValue = 0;
    let longestKey = 0;
    let longestValueValue = 0;
    Object.keys(customMeasures).forEach((element) => {
        const { value, unit } = getValue(customMeasures[element]);
        const formatedValue = numberFormatters(value, customMeasures[element].format, { minimumFractionDigits: 2, unitForValue: isEmpty(unit) ? undefined : unit });
        customMeasures[element].formatedValue = formatedValue;
        const currentLongestValue = element.length > formatedValue.length ? element.length : formatedValue.length;
        longestValue = currentLongestValue > longestValue ? currentLongestValue : longestValue;
        longestKey = element.length > longestKey ? element.length : longestKey;
        longestValueValue = formatedValue.length > longestValueValue ? formatedValue.length : longestValueValue;
    });
    const content = React.createElement(InsQueryStatedElement, { widgetFactoryProps: props, queryState: querystate, hasData: Object.keys(customMeasures).length > 0 },
        React.createElement("div", { className: "quartile-ranking-content" }, Object.keys(customMeasures).map((key) => React.createElement(InsQuartileRankingRow, { key: key, keyColumnWidth: longestKey, valueColumnWidth: longestValueValue, ranking: { ...customMeasures[key], name: key } }))));
    return React.createElement(InsWidget, { sectionId: sectionId, widgetId: widgetId, showMaximize: false, content: content, footer: React.createElement("div", { className: "quartile-ranking-footer", key: "benchmark", title: benchmarkText }, benchmarkText), title: React.createElement(InsWidgetTitle, { ...props }) });
};
